import { gql } from '@apollo/client';
import { useLazyQuery } from '@apollo/client/react';

export const SPOTS_PAGED_WITH_BOX_DUAL_QUERY = gql`
    query getSpotsPagedWithBoxDual(
        $bounds: BoundsInputObject
        $center: CoordinatesInputObject
        $filtersNew: FiltersInputObject
        $publicFilters: FiltersInputObject
        $page: Int
        $hasPhotos: Boolean
        $testCase: String
        $sortBy: SortBy
        $sortOrder: SortOrder
    ) {
        publicSpots: spotsPagedWithBox(
            bounds: $bounds
            center: $center
            filtersNew: $publicFilters
            page: $page
            limit: 3
            hasPhotos: $hasPhotos
            testCase: $testCase
            sortBy: $sortBy
            sortOrder: $sortOrder
        ) {
            spots {
                collection {
                    ...spotFields
                }
            }
        }

        privateSpots: spotsPagedWithBox(
            bounds: $bounds
            center: $center
            filtersNew: $filtersNew
            page: $page
            limit: 10
            hasPhotos: $hasPhotos
            testCase: $testCase
            sortBy: $sortBy
            sortOrder: $sortOrder
        ) {
            spots {
                collection {
                    ...spotFields
                }
            }
        }
    }

    fragment spotFields on Spot {
        id
        title
        rating
        ratingV2
        effectiveRatingV2
        latitude
        longitude
        distanceFrom
        allAmenities(limit: 21) {
            component
            name
        }
        topReview {
            id
            comment
        }
        live
        spotPhotos {
            id
            imageAws
        }
        size
        sizeUnits
        filtered
        price
        offerSniffpass
        reviewsCount
        enclosureType
        fenceHeight
        privateEntry
        dogsPresent
        domesticAnimalsPresent
        description
        peoplePresent
        top
        new
        risingStar
        spotUrl
        country
        state
        city
        host {
            id
            nameAndInitial
        }
        publicPark
        workHours
        fee
    }
`;

export default function useGetSpotsDual() {
    const [getSpotPagedBox, { loading }] = useLazyQuery(SPOTS_PAGED_WITH_BOX_DUAL_QUERY);
    return { getSpotPagedBox, loading };
}
